import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {
    Typography, withStyles, FormControl, FormLabel,
    Radio, RadioGroup, FormControlLabel,
} from "@material-ui/core";

const styles = theme => ({
    root: {

    },
    label: {
        color: '#FFFFFF',
    },
    methodFormControl: {
        marginTop: theme.spacing.unit,
    },
    checkboxRoot: {
        color: '#FFFFFF',
        '&$checked': {
            color: '#FFFFFF'
        }
    },
    bullets: {
        marginTop: theme.spacing.unit/2,

        '& li:not(:first-child)': {
            marginTop: theme.spacing.unit,
        }
    },
    caption: {
        marginTop: theme.spacing.unit,
    },
});

class RegisterStart extends PureComponent {
    render() {
        const {classes, value, onChange} = this.props;

        return (
            <React.Fragment>
                <Typography variant="title" paragraph>
                    Välkommen till Pantanova's WiFi!
                </Typography>
                <Typography variant="body1">
                    Genom att använda detta WiFi får du:
                </Typography>
                <Typography variant="body2" component="span">
                    <ul className={classes.bullets}>
                        <li>Fri tillgång till internet på alla Pantanova's WiFi</li>
                        <li>Attraktiva erbjudanden när någon slänger skräp i din närhet</li>
                    </ul>
                </Typography>
                <FormControl component="fieldset" className={classes.methodFormControl}>
                    <FormLabel component="legend" classes={{root: classes.label}} focused={false}>Hur vill du ta del av erbjudanden?</FormLabel>
                    <RadioGroup
                        name="method"
                        className={classes.methodRadioGroup}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    >
                        <FormControlLabel value="messenger" control={<Radio classes={{root: classes.checkboxRoot}} color="default"/>} label="Facebook" />
                        <FormControlLabel value="sms"       control={<Radio classes={{root: classes.checkboxRoot}} color="default"/>} label="SMS" />
                    </RadioGroup>
                </FormControl>
                <Typography variant="caption" className={classes.caption}>
                    Genom att klicka acceptera, godkänner du Pantanova's villkor.
                </Typography>
            </React.Fragment>
        );
    }
}

export default compose(
    withStyles(styles, {withTheme: true}),
)(RegisterStart);



// WEBPACK FOOTER //
// ./src/containers/Register/Start.js